import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DevolucionDineroModalService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();

  private orderDataSubject = new BehaviorSubject<any>(null);
  orderData$ = this.orderDataSubject.asObservable();

  toggleModal(value?: boolean): void {
    const newValue = value !== undefined ? value : !this.isOpenSubject.value;
    this.isOpenSubject.next(newValue);
  }

  setOrderData(data: any): void {
    this.orderDataSubject.next(data);
  }

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }
}